export const freeThresholdGrams = 9999000
export const lowThresholdGrams = 999000
export const freeThresholdPence = 4000
export const shippingPrice = 449
export const lowShippingPrice = 299
